// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1Y24F","question":"styles_question__3SYK1","answer":"styles_answer__12UOo","itemWrapper":"styles_itemWrapper__2HfLb"};